<template>
  <div style="height: 257px; background-color: #FBFBFB; padding: 0px; text-align: center;">
        <div style="height: 12px;"></div>
        <div class="title very-big-title my-sans-font">{{ $t("HelpObject.contactUs") }}</div>

        <div style="padding-left: 40px; padding-right: 40px;">
            <!-- 公司地址和 客服中心 -->
            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 20px; margin-top: 20px;">
                <div style="text-align: left;"> {{ $t("CommonObject.companyAddress") }}:<span style="font-weight:bold;">2 Jurong East Street 21 #03-186 IMM Building Singapore 609601</span></div>
                <div class="flex-sb">
                    <div>{{ $t("CommonObject.newsLetter") }}</div>
                    <div>
                        <div class="text-left m-l-20">Email:</div>
                        <el-input v-model="email" style="width: 360px; margin-left: 8px; margin-right: 8px;">
                        </el-input>
                        
                    </div>
                    <div>
                        <el-button class="primary-button-main" style="border-radius: 20px; width: 80px; height: 40px; color: white;" @click="onClickJoinNewsLetter">{{ $t("CommonObject.join") }}</el-button>
                    </div> 
                </div>
            </div>

            <!-- 联系方式和邮箱 -->
            <div style="display: flex; flex-direction: row; align-items: center; justify-content: space-between; margin-bottom: 16px;">
            <!-- <div style="width: 300px;"> -->
                <ContactItem title="General Enquiries & Customer Support" phone="+65 6256 1327" email="online@hansvision.com"></ContactItem>
                <ContactItem title="Technical" phone="+65 6256 1327" email="helpdesk@hansvision.com"></ContactItem>
                <ContactItem title="Sales" phone="+65 6256 1350" email="sales@hansvision.com"></ContactItem>
                <ContactItem title="Business" phone="+65  96281379" email="tansh@ckpl.creative.com"></ContactItem>
            </div>
            <!-- </div> -->
        </div>
        <div class="copyright-footer">
            © 2023 Creative Knowledge Labs Pte Ltd. All rights reserved.
        </div>
    </div>
</template>

<script>

import ContactItem from '@/components/common/contact_item.vue'
import {Encrypt} from '@/api/api_utils.js'
export default {
    components:{
        ContactItem     
    },
    name:'PageFooter',
    data(){return{
        email:''
    }},
    methods:{
        onClickJoinNewsLetter(){
            // console.log('单价按钮',this.email)
            if(this.email ==''){
                return
            }
            const mal = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/
            if (!(mal.test(this.email))) {
                this.$toastError(this.$t('ShopObject.invalidEmail'))
                return
            } 
            // 提交
            // console.log('提交订阅')

            this.doSubmit()

        },
        doSubmit(){
            let body = JSON.stringify({email:this.email})
            this.$request.post('/user/addNewsEmail',body).then(response=>{
                // console.log("试用",response)
                if(response.data.code == 200){
                    this.$toastSuccess(this.$t('CommonObject.success'))
                    this.email = ''
                }else {
                    this.$toastError(this.$t('CommonObject.fail'))
                }
            }).catch(e=>{
                this.$toastError(this.$t('CommonObject.fail'))
            })
        }
    }
}
</script>

<style scoped>

    .copyright-footer {
    height: 72px;
    background-color: #626262;
    color: white;
    display: flex;
    align-items: center;
    align-content: center;
    justify-content: center;
    justify-items: center;
    }
    .title {
        color: #222222; 
        font-weight: bold;
    }
</style>


// WEBPACK FOOTER //
// src/components/common/page_footer.vue